import React from 'react';

function ChervonDown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.718"
      height="8.178"
      viewBox="0 0 20.718 8.178"
    >
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3px"
        d="M2265.895,2093.736l8.319,4.638,8.319-4.638"
        transform="translate(-2263.854 -2091.696)"
      />
    </svg>
  );
}

export default ChervonDown;
